export default "__VITE_ASSET__CczlaSa4__"